module.exports = __webpack_public_path__ + "static/media/train-0-0-wheel-large.7a0feac6.png";